import { ShieldCheck, FileBadge, Landmark, BadgeDollarSign, Truck } from "lucide-react";
import { TRUST_ITEMS } from "../data/site";

const ICONS = [ShieldCheck, FileBadge, Landmark, BadgeDollarSign, Truck];

export const TrustStrip = () => (
  <div data-testid="trust-strip" className="border-y border-white/[0.07] bg-surface/50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
      {TRUST_ITEMS.map((t, i) => {
        const Icon = ICONS[i];
        return (
          <span key={t} className="inline-flex items-center gap-2 text-[11px] sm:text-xs font-mono tracking-[0.14em] uppercase text-slate-300">
            <Icon size={14} className="text-accent" strokeWidth={2} aria-hidden="true" />
            {t}
          </span>
        );
      })}
    </div>
  </div>
);
